export default {
  setChoosingFieldId (state: {[key:string]: string}, value: string) {
    state.id = value
  },

  setClickFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.clickFlag = flag
  },

  /* 圃場詳細が未取得の際、取得でき次第対象の圃場一覧を選択状態で表示する用 */
  setChooseFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.chooseFlag = flag
  },

  setChoosingFieldData (state: {[key:string]: any}, value: any) {
    state.fieldData.fieldId = value.fieldId
    state.fieldData.fieldName = value.fieldName
  },

  /* モーダル用 */
  setModalChooseFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.modalChooseFlag = flag
  },

  setChoosingModalFieldId (state: {[key:string]: string}, value: string) {
    state.modalId = value
  },

  setModalPlantingId (state: any, value: string) {
    state.modalPlantingId = value
  }
}
